import type { FunctionComponent, SVGProps } from 'react';

import { Component as FrontDoor1 } from 'src/assets/icons/door-groups/front-doors/door-1.svg';
import { Component as FrontDoor10 } from 'src/assets/icons/door-groups/front-doors/door-10.svg';
import { Component as FrontDoor11 } from 'src/assets/icons/door-groups/front-doors/door-11.svg';
import { Component as FrontDoor12 } from 'src/assets/icons/door-groups/front-doors/door-12.svg';
import { Component as FrontDoor13 } from 'src/assets/icons/door-groups/front-doors/door-13.svg';
import { Component as FrontDoor14 } from 'src/assets/icons/door-groups/front-doors/door-14.svg';
import { Component as FrontDoor2 } from 'src/assets/icons/door-groups/front-doors/door-2.svg';
import { Component as FrontDoor3 } from 'src/assets/icons/door-groups/front-doors/door-3.svg';
import { Component as FrontDoor4 } from 'src/assets/icons/door-groups/front-doors/door-4.svg';
import { Component as FrontDoor5 } from 'src/assets/icons/door-groups/front-doors/door-5.svg';
import { Component as FrontDoor6 } from 'src/assets/icons/door-groups/front-doors/door-6.svg';
import { Component as FrontDoor7 } from 'src/assets/icons/door-groups/front-doors/door-7.svg';
import { Component as FrontDoor8 } from 'src/assets/icons/door-groups/front-doors/door-8.svg';
import { Component as FrontDoor9 } from 'src/assets/icons/door-groups/front-doors/door-9.svg';
import { Component as GarageDoor1 } from 'src/assets/icons/door-groups/garage-doors/door-1.svg';
import { Component as GarageDoor2 } from 'src/assets/icons/door-groups/garage-doors/door-2.svg';
import { Component as GarageDoor3 } from 'src/assets/icons/door-groups/garage-doors/door-3.svg';
import { Component as GarageDoor4 } from 'src/assets/icons/door-groups/garage-doors/door-4.svg';
import { Component as GarageDoor5 } from 'src/assets/icons/door-groups/garage-doors/door-5.svg';
import { Component as GarageDoor6 } from 'src/assets/icons/door-groups/garage-doors/door-6.svg';
import { Component as GarageDoor7 } from 'src/assets/icons/door-groups/garage-doors/door-7.svg';
import { Component as GarageDoor8 } from 'src/assets/icons/door-groups/garage-doors/door-8.svg';
import { Component as ServiceDoor1 } from 'src/assets/icons/door-groups/service-doors/door-1.svg';
import { DoorGroup } from 'src/modules/designStudio/helpers/data/TemplateDesignConfig';
import type { FilteredColorsData } from 'src/modules/designStudio/machines/productCatalog/types';
import type {
  DoorCatalog,
  DoorStyle,
  DoorStyles,
  DoorVariation,
} from 'src/modules/designStudio/providers/ProductCatalogProvider/doors/types';
import type {
  ColorCatalog,
  ColorCatalogEntry,
} from 'src/modules/designStudio/types';
import type {
  GetDoorProductsQuery,
  ProductCatalogProduct,
  ProductCatalogVariation,
} from 'src/shared/graphql/generated';

export const doorGroupIcons: Record<
  DoorGroup,
  FunctionComponent<SVGProps<SVGSVGElement>>
> = {
  [DoorGroup.FRONT]: FrontDoor6,
  [DoorGroup.SERVICE]: ServiceDoor1,
  [DoorGroup.GARAGE]: GarageDoor1,
  [DoorGroup.SLIDING_GLASS]: FrontDoor1,
};

const DoorSVGs: Record<
  DoorGroup,
  {
    id: string;
    name: string;
    icon: FunctionComponent<SVGProps<SVGSVGElement>>;
  }[]
> = {
  [DoorGroup.FRONT]: [
    {
      id: '5c3b24ac-2854-468b-9591-b14b060da08c',
      name: 'Flush ',
      icon: FrontDoor1,
    },
    {
      id: 'e5651559-2d67-4e62-a75a-1ad9029f3195',
      name: '2 Panel ',
      icon: FrontDoor2,
    },
    {
      id: '36bf9987-c8b7-470a-a723-513fb65eb2ce',
      name: '6 Panel ',
      icon: FrontDoor3,
    },
    {
      id: '0790ab91-348f-42a6-b008-a2e55e1992b2',
      name: '2 Panel Arch Plank ',
      icon: FrontDoor4,
    },
    {
      id: '50d169c2-5e7b-4abd-9d47-8f6421cf2ff3',
      name: 'Craftsman ',
      icon: FrontDoor5,
    },
    {
      id: '0b794eb1-dd2d-4900-a28d-25dc9b8dccc3',
      name: 'Full Light ',
      icon: FrontDoor6,
    },
    {
      id: 'b926c0d4-96bb-44a2-ac8a-2eb2347860ce',
      name: '3/4 Light ',
      icon: FrontDoor7,
    },
    {
      id: '1615a772-7173-4537-a206-d4af001c571e',
      name: '3 Light ',
      icon: FrontDoor8,
    },
    {
      id: '5a7d5ec8-3cfa-48e3-b95a-fbe327c7a79a',
      name: '4 Light ',
      icon: FrontDoor9,
    },
    {
      id: '88913441-9574-4bc9-ac43-81aa08f873ff',
      name: '3/4 Oval Light ',
      icon: FrontDoor10,
    },
    {
      id: '61854ded-2024-4286-abb4-723a49604bae',
      name: '1/2 Light 1 Panel ',
      icon: FrontDoor11,
    },
    {
      id: '3df94848-9315-46cb-a0bf-651bbc98deed',
      name: 'Craftsman Light ',
      icon: FrontDoor12,
    },
    {
      id: '1a357df5-9150-4110-8eff-eb554234e47e',
      name: 'Fan Light Rectangle ',
      icon: FrontDoor13,
    },
    {
      id: '27e347a0-2717-4c27-b886-2629b863e2e5',
      name: 'Twin Colonial Light ',
      icon: FrontDoor14,
    },
  ],
  [DoorGroup.SERVICE]: [
    {
      id: '72fc206f-5651-407e-a10b-62cddbec06c8',
      name: 'Service Door ',
      icon: ServiceDoor1,
    },
  ],
  [DoorGroup.GARAGE]: [
    {
      id: 'c2199e4a-8de3-4fff-bce5-447523de6e6e',
      name: 'Carriage House Style Insulated with Windows',
      icon: GarageDoor1,
    },
    {
      id: 'f804e1ed-0b8c-4e51-a9b5-b7ffb18be669',
      name: 'Modern Steel and Wood 2',
      icon: GarageDoor3,
    },
    {
      id: '14811361-6daa-41f1-9a92-544c16b54425',
      name: 'Modern Steel and Wood 3',
      icon: GarageDoor2,
    },
    {
      id: 'bbfd1345-01f2-4a12-8f41-7f5654b074fb',
      name: 'Bridgeport Steel ',
      icon: GarageDoor7,
    },
    {
      id: 'b6df0cf0-30c8-42b2-a5ca-ada2acc56363',
      name: 'Classic Steel and Wood ',
      icon: GarageDoor6,
    },
    {
      id: 'b2cb781b-ce2b-4ab8-a1e0-19798ed148bb',
      name: 'Modern Steel and Wood ',
      icon: GarageDoor4,
    },
    {
      id: '6d558938-a445-49fc-aded-9c54526bc4d0',
      name: 'Carriage House Style Insulated ',
      icon: GarageDoor7,
    },
    {
      id: '2b65167c-7586-46e5-b852-800e6bab76c9',
      name: 'Classic Steel and Wood with Windows',
      icon: GarageDoor5,
    },
    {
      id: 'a1849ab2-030b-4b29-afce-6bf0e5a8aca6',
      name: 'Bridgeport Steel with Windows',
      icon: GarageDoor8,
    },
  ],
  [DoorGroup.SLIDING_GLASS]: [],
};

export const POPULAR_DOOR_COLORS = {
  name: 'Popular',
  colors: [
    '#F3F1F1',
    '#C5B3B3',
    '#000000',
    '#FFA39C',
    '#D1553B',
    '#4C3F37',
    '#CFC3AD',
    '#D3C05B',
    '#CDC65C',
    '#C5C9BB',
    '#788075',
    '#70BCC5',
    '#58ACB8',
    '#9DAEB8',
    '#596873',
    '#BCD1E4',
    '#314B66',
    '#385579',
    '#0063DB',
    '#3B3C3E',
    '#604357',
    '#8E3B43',
  ],
};

export const emptyCatalog: DoorCatalog = {
  stylesByDoorType: {
    [DoorGroup.FRONT]: {
      styles: [],
    },
    [DoorGroup.SERVICE]: {
      styles: [],
    },
    [DoorGroup.GARAGE]: {
      styles: [],
    },
    [DoorGroup.SLIDING_GLASS]: {
      styles: [],
    },
  },
  colors: {},
};

export const createDoorVariation = (
  doorGroup: DoorGroup,
  variation: ProductCatalogVariation,
): DoorVariation => ({
  uuid: variation.id,
  canTile: false, // variation.texture?.repeatable ?? false, Garage doors need to be updated to false, not sure how to chnage in product catalog so this is temporary fix
  color: variation.color?.hex ?? undefined,
  height: variation.texture?.height ?? Infinity,
  styleName: variation.name,
  textureId: variation.textureId!,
  type: doorGroup,
  url: '',
  width: variation.texture?.width ?? Infinity,
});

const DoorGroupByLabel: Record<number, DoorGroup> = {
  408: DoorGroup.FRONT,
  103: DoorGroup.GARAGE,
  2351: DoorGroup.SERVICE,
};

export const createDoorStyle = (product: ProductCatalogProduct): DoorStyle => {
  const doorGroup = DoorGroupByLabel[product.labelId ?? 0];
  const icon =
    DoorSVGs[doorGroup].find(e => e.id === product.id)?.icon ??
    doorGroupIcons[doorGroup];

  return {
    uuid: product.id,
    icon,
    type: doorGroup,
    name: product.name,
    variations: product.variations.map(v => createDoorVariation(doorGroup, v)),
  };
};

export const createDoorStyles = (data: GetDoorProductsQuery): DoorStyles => {
  const catalog: DoorStyles = {
    [DoorGroup.FRONT]: {
      styles: [],
    },
    [DoorGroup.SERVICE]: {
      styles: [],
    },
    [DoorGroup.GARAGE]: {
      styles: [],
    },
    [DoorGroup.SLIDING_GLASS]: {
      styles: [],
    },
  };
  data.productCatalogProductsByTag.nodes?.forEach(product => {
    if (product) {
      const style = createDoorStyle(product as ProductCatalogProduct);
      catalog[style.type].styles.push(style);
    }
  });
  /**
   * We sort variations in astyle in ascending order of aspect ratio. Because of the way the design config system works
   * the order of the variations matters for which styles are applied if two textures are within the aspect ratio tolerance for a door.
   * By ordering the doors in ascending order if two textures can be applied to a door, we will consistently apply the largest, since it is the last in the list of variations.
   */
  Object.keys(catalog).forEach(key => {
    const { styles } = catalog[key as DoorGroup];
    styles.forEach(style => {
      style.variations.sort((v, w) => v.width / v.height - w.width / w.height);
    });
  });
  return catalog;
};

export const createDoorColors = (
  filteredColors: FilteredColorsData,
): ColorCatalog => {
  const colorCatalog: ColorCatalog = {};

  /**
   * We want doors to use the same colors as walls.
   */
  filteredColors.WALLS.forEach(color => {
    const colorEntry = {
      group: color.group,
      name: color.name,
      hex: color.color,
    };

    if (!colorCatalog[color.group]) {
      colorCatalog[color.group] = [];
    }

    colorCatalog[color.group].push(colorEntry);
  });

  /**
   * Doors have a unique popular color group, which we add here.
   */
  colorCatalog[POPULAR_DOOR_COLORS.name] = POPULAR_DOOR_COLORS.colors.map(
    color => ({ group: POPULAR_DOOR_COLORS.name, name: '', hex: color }),
  );

  return colorCatalog;
};

export const createDoorCatalog = (
  data: GetDoorProductsQuery,
  filteredColors: FilteredColorsData,
): DoorCatalog => ({
  stylesByDoorType: createDoorStyles(data),
  colors: createDoorColors(filteredColors),
});

export const WoodGroup = 'Woods';

export const extractWoodColorsFromStyle = (
  style: DoorStyle,
): ColorCatalogEntry[] => {
  const uniqueColors: ColorCatalogEntry[] = [];
  style.variations
    .filter(variation => variation.color)
    .forEach(variation => {
      if (!uniqueColors.find(c => c.hex === variation.color)) {
        uniqueColors.push({
          group: WoodGroup,
          name: variation.color!,
          hex: variation.color!,
        });
      }
    });
  return uniqueColors;
};

export const createColorCatalogForStyle = (
  style: DoorStyle,
  colorCatalog: ColorCatalog,
): ColorCatalog => {
  const woodColors = extractWoodColorsFromStyle(style);
  if (woodColors.length > 0) {
    const { Popular, ...others } = colorCatalog;
    return {
      [WoodGroup]: woodColors,
      Popular,
      ...others,
    };
  }
  return colorCatalog;
};

export const isVariationWood = (variation: DoorVariation): boolean =>
  !!variation.color;

export const getWoodVariations = (
  style: DoorStyle,
  hex: string,
): DoorVariation[] =>
  style.variations.filter(v => isVariationWood(v)).filter(v => v.color === hex);

export const getNonWoodVariations = (style: DoorStyle): DoorVariation[] =>
  style.variations.filter(v => !isVariationWood(v));
